import {combine} from 'effector';
import {createGate} from 'effector-react';

import {
    exportAppealsRegistry,
    fetchAppealsRegistry,
    fetchAppealThemes,
    fetchNkBranches,
    fetchNkEmployees,
} from 'api';
import {createGridTableModel} from 'core/hooks/grid2.0';
import {rootDomain} from 'core/rootDomain';
import {
    AppealsRegistryResponse,
    AppealExportFormat,
    AppealTheme,
    ComplaintsAccessors,
    NkBranch,
    NkEmployee,
} from 'types';

const domain = rootDomain.createDomain('complaintsDomain');

export const Gate = createGate<{
    canViewPersonnel: boolean;
    canManageBranches: boolean;
}>('ComplaintsGate');

export const fetchDataFx = domain.createEffect({
    name: 'fetchAppealsRegistryFx',
    handler: fetchAppealsRegistry,
});
export const fetchEmployeesFx = domain.createEffect({
    name: 'fetchNkEmployeesFx',
    handler: fetchNkEmployees,
});
export const fetchBranchesFx = domain.createEffect({
    name: 'fetchNkBranchesFx',
    handler: fetchNkBranches,
});
export const fetchThemesFx = domain.createEffect({
    name: 'fetchAppealThemesFx',
    handler: fetchAppealThemes,
});
export const exportDataFx = domain.createEffect({
    name: 'exportAppealsRegistryFx',
    handler: exportAppealsRegistry,
});

export const exportRequested = domain.createEvent<AppealExportFormat>();

export const {
    filters$,
    filtersChanged,
    filtersReset,
    defaultFilters,
    sortings$,
    sortingsChanged,
    sortingsReset,
    defaultSortings,
    pageNumber$,
    pageNumberChanged,
    pageSize$,
    pageSizeChanged,
    tableStateChanged,
    stateReset,
} = createGridTableModel({
    domain,
    Gate,
    defaultSortings: {
        [ComplaintsAccessors.createdAt]: true,
    },
});

export const data$ = domain.createStore<AppealsRegistryResponse | null>(null);
export const employees$ = domain.createStore<NkEmployee[]>([]);
export const branches$ = domain.createStore<NkBranch[]>([]);
export const themes$ = domain.createStore<AppealTheme[]>([]);

export const complaintsState$ = combine({
    data: data$,
    employees: employees$,
    branches: branches$,
    themes: themes$,
    filters: filters$,
    sortings: sortings$,
    isLoading: fetchDataFx.pending,
    isExporting: exportDataFx.pending,
});
